export const SUPPORTED_LOCALES = ['it', 'en']
export const DEFAULT_LOCALE = 'en'

export function isLocale(value) {
  return SUPPORTED_LOCALES.includes(value)
}

/** Path interno con prefisso lingua, es. localePath('en', '/miniatures') → /en/miniatures */
export function localePath(locale, path = '/') {
  const normalized = path === '/' ? '' : path.startsWith('/') ? path : `/${path}`
  return `/${locale}${normalized}`
}

export function localeFromPathname(pathname) {
  const segment = pathname.split('/').filter(Boolean)[0]
  return isLocale(segment) ? segment : null
}

/** Path senza prefisso lingua (es. /en/miniatures/foo → /miniatures/foo). */
export function pathWithoutLocale(pathname) {
  const parts = pathname.split('/').filter(Boolean)
  if (parts.length > 0 && isLocale(parts[0])) {
    const rest = parts.slice(1).join('/')
    return rest ? `/${rest}` : '/'
  }
  return pathname || '/'
}
